import React from 'react';

const ChordCaptainIcon = () => (
   <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 8 62.2 62.2"
      className="svg-icon"
   >
      <g id="Layer_2" data-name="Layer 2">
         <g id="Layer_1-2" data-name="Layer 1">
            <path
               className="svg-icon-background"
               d="M60.94,18.06a9.53,9.53,0,0,0-9.62-9.38l-30.06.37V3.84A3.84,3.84,0,0,0,17.43,0h-4A3.84,3.84,0,0,0,9.62,3.84V9.23A9.5,9.5,0,0,0,.74,18.81l.52,41.44a9.54,9.54,0,0,0,9.5,9.38l41.31-.52a9.5,9.5,0,0,0,9.38-9.62Z"
            />
            <rect
               className="svg-icon-decoration"
               x="31.1"
               y="9.44"
               width="16"
               height="59.44"
            />
            <path d="M51.7,7.94H18.91v3H51.7a7.52,7.52,0,0,1,7.5,7.5V59.88a7.51,7.51,0,0,1-7.5,7.5H10.5A7.5,7.5,0,0,1,3,59.88V18.44a7.51,7.51,0,0,1,7.5-7.5h.41v-3H10.5A10.51,10.51,0,0,0,0,18.44V59.88a10.51,10.51,0,0,0,10.5,10.5H51.7a10.51,10.51,0,0,0,10.5-10.5V18.44A10.51,10.51,0,0,0,51.7,7.94Z" />
            <rect x="13.6" y="38.8" width="3" height="30.08" />
            <rect x="29.96" y="23.72" width="3" height="45.16" />
            <rect x="45.6" y="23.72" width="3" height="45.16" />
            <path
               className="svg-icon-highlight"
               d="M17.43,40.66h-4a3.84,3.84,0,0,1-3.83-3.84v-33A3.84,3.84,0,0,1,13.45,0h4a3.84,3.84,0,0,1,3.83,3.84v33A3.84,3.84,0,0,1,17.43,40.66ZM13.45,3a.84.84,0,0,0-.83.84v33a.83.83,0,0,0,.83.84h4a.83.83,0,0,0,.83-.84v-33A.84.84,0,0,0,17.43,3Z"
            />
            <rect
               className="svg-icon-background"
               x="27.13"
               y="1.5"
               width="8.65"
               height="37.66"
               rx="2.34"
            />
            <path d="M33.44,40.66h-4a3.84,3.84,0,0,1-3.84-3.84v-33A3.84,3.84,0,0,1,29.47,0h4a3.84,3.84,0,0,1,3.84,3.84v33A3.84,3.84,0,0,1,33.44,40.66ZM29.47,3a.85.85,0,0,0-.84.84v33a.84.84,0,0,0,.84.84h4a.84.84,0,0,0,.84-.84v-33A.85.85,0,0,0,33.44,3Z" />
            <rect
               className="svg-icon-decoration"
               x="43.15"
               y="1.5"
               width="8.65"
               height="37.66"
               rx="2.34"
            />
            <path d="M49.46,40.66h-4a3.84,3.84,0,0,1-3.83-3.84v-33A3.84,3.84,0,0,1,45.48,0h4a3.84,3.84,0,0,1,3.83,3.84v33A3.84,3.84,0,0,1,49.46,40.66ZM45.48,3a.84.84,0,0,0-.83.84v33a.83.83,0,0,0,.83.84h4a.83.83,0,0,0,.83-.84v-33A.84.84,0,0,0,49.46,3Z" />
         </g>
      </g>
   </svg>
);

export { ChordCaptainIcon };
